import { cn } from '@/lib/utils';

const NEAR_LIMIT_PERCENT = 90;

interface UsageMeterProps {
    current: number;
    max?: number;
    label: string;
    className?: string;
}

export function UsageMeter({
    current,
    max,
    label,
    className,
}: UsageMeterProps) {
    const usagePercent =
        max && max > 0 ? Math.min(100, (current / max) * 100) : 0;
    const isFull = usagePercent >= 100;
    const isNearLimit = usagePercent >= NEAR_LIMIT_PERCENT;

    const barColorClass = isFull
        ? 'bg-danger-300'
        : isNearLimit
          ? 'bg-warning-100'
          : 'bg-white-100';

    return (
        <div className={cn('flex flex-col gap-1.5 max-w-xs', className)}>
            <span className="text-sm text-grey-300">{label}</span>
            {max !== undefined && (
                <div className="h-1 w-full rounded-full bg-grey-600 overflow-hidden">
                    <div
                        className={cn('h-full transition-all', barColorClass)}
                        style={{ width: `${usagePercent}%` }}
                    />
                </div>
            )}
        </div>
    );
}
